module.exports = __webpack_public_path__ + "style/img/Group 2258(3).ef8110bd.png";